/* eslint default-param-last: 0 */

import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { integrationExecutionStates } from '../../hooks/useIntegrationExecutionsHook';

const integrationExecutionActions = mapDefaultValuesToActions(integrationExecutionStates);

export default reduxReducerHelper(integrationExecutionActions, integrationExecutionStates);
